function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './userpic.scss';
import template from './userpic.html';

export var UserpicComponent = {
  template: template,
  styles: styles,
  bindings: {
    profileMode: "<" },

  controller: /*#__PURE__*/function () {UserpicComponentController.$inject = ["$http", "$rootScope", "AccountImageModel", "gplansConf", "UserService"];
    function UserpicComponentController($http, $rootScope, AccountImageModel, gplansConf, UserService) {
      "ngInject";_classCallCheck(this, UserpicComponentController);
      console.log(this);
      this.tumb = '';
      this.$http = $http;
      this.$rootScope = $rootScope;
      this.AccountImageModel = AccountImageModel;
      this.gplansConf = gplansConf;
      this.UserService = UserService;
      this.isloading = false;
    }_createClass(UserpicComponentController, [{ key: "fileNameChanged", value: function fileNameChanged(

      $event) {
        this.fileName = $event.target.files[0].name;
        this.image = $event.target.files[0];
        this.showSaveButton = true;
      } }, { key: "$onInit", value: function $onInit()

      {var _this = this;
        this.update();
        this.$rootScope.$on('avatar-uploded', function () {_this.update();});
      } }, { key: "update", value: function update()

      {var _this2 = this;
        this.AccountImageModel.query().then(function (res) {
          if (res.length) {
            _this2.avatarId = res[0].id;
            _this2.$rootScope.$broadcast('avatar-remove');
            res.length ? _this2.avatar = res[0].image.small :
            _this2.UserService.data.facebook_uid ?
            _this2.avatar = 'https://graph.facebook.com/' + $ctrl.UserService.data.facebook_uid + '/picture?redirect=1&width=100&height=100' :
            _this2.avatar = '';
          } else {
            _this2.avatar = '';
            _this2.$rootScope.$broadcast('avatar-remove');
          }
        });
      } }, { key: "saveImage", value: function saveImage()

      {var _this3 = this;
        var fd = new FormData();
        fd.append('image', this.image);
        this.isloading = true;
        this.$http.post(this.gplansConf.API_URL + '/api/v1/account-images/', fd, {
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined } }).

        then(function (res) {
          _this3.image = null;
          _this3.fileName = null;
          _this3.showSaveButton = false;
          _this3.$rootScope.$emit('avatar-uploded');
          _this3.isloading = false;
        }, function (err) {
          console.log('account image fail ' + err.data);
        });
      } }, { key: "deleteImage", value: function deleteImage()

      {var _this4 = this;
        var avatarModel = new this.AccountImageModel({ id: this.avatarId });
        avatarModel.$destroy().then(function (res) {
          _this4.update();
        });
      } }]);return UserpicComponentController;}() };